export default __webpack_public_path__ + "static/media/groundtruth_brand.6aeef2bf.svg";